var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDashboardBreak(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 42,
    viewBox: "0 0 43 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 21.5,
    cy: 21,
    r: 21,
    fill: "#FFEFF9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 29H20.9433M20.9433 29H21.0567M20.9433 29C20.9622 29.0002 20.9811 29.0002 21 29.0002C21.0189 29.0002 21.0378 29.0002 21.0567 29M20.9433 29C17.1034 28.9695 14 25.8468 14 21.9998V17.9229C14 17.4131 14.4131 17 14.9229 17H27.0767C27.5865 17 28 17.4131 28 17.9229V18M21.0567 29H28M21.0567 29C24.8966 28.9695 28 25.8468 28 21.9998M28 18H29.5C30.8807 18 32 19.1193 32 20.5C32 21.8807 30.8807 23 29.5 23H28V21.9998M28 18V21.9998M25 12L24 14M22 12L21 14M19 12L18 14",
    stroke: "#821169",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardBreak);
export default __webpack_public_path__ + "static/media/dashboardBreak.22a3b9d54916cc3412159264de292157.svg";
export { ForwardRef as ReactComponent };